import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import media from '../../utils/media'

const Container = styled.div`
  margin-bottom: 30px;
  ${media.mobileL`
    padding: 0 17px;
  `}
`

const Border = styled.div`
  width: 100%;
  height: 14px;
  border: 1px solid ${props => props.color};
  border-radius: 7px;
  background-color: #ffffff;
`

const Bar = styled.div`
  height: 100%;
  border-radius: 7px;
  background-color: ${props => props.color};
  width: ${props => props.percent}%;
  max-width: 100%;
  transition: width 0.4s linear;
`

const HiddenSpan = styled.div`
  visibility: hidden;
  height: 0;
  font-size: 0;
`

export default function ProgressBar({ color }) {
  const [{ percent }] = useStoreState(state => [state.quiz])
  // first question is a first percent progress
  // last question is not 100% percent
  return (
    <Container>
      <Border color={color}>
        <Bar color={color} percent={percent}>
          <HiddenSpan>h</HiddenSpan>
        </Bar>
      </Border>
    </Container>
  )
}
